import Vue from 'vue'
import VueJwtDecoder from 'vue-jwt-decode'
import Router from 'vue-router'
import store from '../store/'
import analytics from '../analytics'

import Account from '@/components/account/Account'
import AccountPeople from '@/components/account/People'
import AccountDetails from '@/components/account/Details'

import Challenges from '@/components/challenges/Challenges'
import Challenge from '@/components/challenges/Challenge'
import ChallengeThemes from '@/components/challenges/Themes'
import ChallengeTheme from '@/components/challenges/Theme'

import Landing from '@/components/landing/Landing'
import PasswordLogin from '@/components/landing/PasswordLogin'
import EmailLogin from '@/components/landing/EmailLogin'
import RecoverPassword from '@/components/landing/RecoverPassword'
import Signup from '@/components/landing/Signup'

import TermsOfService from '@/components/landing/TermsOfService/TermsOfService'
import PrivacyPolicy from '@/components/landing/PrivacyPolicy/PrivacyPolicy'
// import EngagementSnapshot from '@/components/snapshoshowPpt/Engagement'
import EmbeddableLoginButton from '@/components/embeddable/LoginButton'
import ValidateEmail from '@/components/validate/Validate'
import Personal from '@/components/personal/Personal'
import Survey from '@/components/personal/Survey'

import Results from '@/components/personal/Results'
import PersonalEngagementReport from '@/components/personal/reports/PersonalEngagement'
import PersonalVigorReport from '@/components/personal/reports/PersonalVigor'
import PersonalAbsorptionReport from '@/components/personal/reports/PersonalAbsorption'
import PersonalDedicationReport from '@/components/personal/reports/PersonalDedication'
import PersonalAnxietyReport from '@/components/personal/reports/PersonalAnxiety'
import PersonalPsychosocialWorkloadReport from '@/components/personal/reports/PersonalPsychosocialWorkload'
import Profile from '@/components/personal/Profile'
import ProfileDetails from '@/components/personal/profile/ProfileDetails'
import ProfileChangePassword from '@/components/personal/profile/ChangePassword'
import ProfileMessagingOptions from '@/components/personal/profile/MessagingOptions'
import ProfileRemoveAccount from '@/components/personal/profile/RemoveAccount'
import TeamReports from '@/components/team/Reports'
import TeamEngagementReport from '@/components/team/reports/TeamEngagement'
import TeamVigorReport from '@/components/team/reports/TeamVigor'
import TeamAbsorptionReport from '@/components/team/reports/TeamAbsorption'
import TeamDedicationReport from '@/components/team/reports/TeamDedication'
import TeamAnxietyReport from '@/components/team/reports/TeamAnxiety'
import TeamAdvocacyReport from '@/components/team/reports/TeamAdvocacy'
import TeamSatisfactionReport from '@/components/team/reports/TeamSatisfaction'

import Journal from '@/components/personal/journal/Journal'

Vue.use(Router)

const REQUIRED_SESSION_STATE_OWNER = 'REQUIRED_SESSION_STATE_OWNER'
const REQUIRED_SESSION_STATE_USER = 'REQUIRED_SESSION_STATE_USER'
const REQUIRED_SESSION_STATE_VISITOR = 'REQUIRED_SESSION_STATE_VISITOR'
const REQUIRED_SESSION_STATE_ANY = 'REQUIRED_SESSION_STATE_ANY'

const routes = [
  // { path: '/validate-email', redirect: '/tour' },
  {
    path: '/welcome',
    name: 'Landing',
    component: Landing,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_VISITOR
    },
    children: [
      {
        path: 'sign-in',
        name: 'PasswordLogin',
        component: PasswordLogin
      },
      {
        path: 'email-login',
        name: 'EmailLogin',
        component: EmailLogin
      },
      {
        path: 'recover-password',
        name: 'RecoverPassword',
        component: RecoverPassword
      }
    ]
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: TermsOfService,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_ANY
    }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_ANY
    }
  },
  {
    path: '/embeddable/login-button',
    name: 'EmbeddableLoginButton',
    component: EmbeddableLoginButton,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_ANY
    }
  },
  {
    path: '/validate-email',
    name: 'ValidateEmail',
    component: ValidateEmail,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_ANY
    }
  },
  // {
  //   path: '/journey',
  //   name: 'Journey',
  //   component: Journey,
  //   meta: {
  //     requiredSessionState: REQUIRED_SESSION_STATE_USER
  //   }
  // },
  {
    path: '/team/reports',
    name: 'TeamReports',
    component: TeamReports,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_USER
    },
    children: [
      {
        name: 'TeamEngagementReport',
        path: 'engagement',
        component: TeamEngagementReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamVigorReport',
        path: 'vigor',
        component: TeamVigorReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamAbsorptionReport',
        path: 'absorption',
        component: TeamAbsorptionReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamDedicationReport',
        path: 'dedication',
        component: TeamDedicationReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamAnxietyReport',
        path: 'anxiety-gad-7',
        component: TeamAnxietyReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamAdvocacy',
        path: 'advocacy',
        component: TeamAdvocacyReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      },
      {
        name: 'TeamSatisfaction',
        path: 'satisfaction',
        component: TeamSatisfactionReport,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER,
          transitionName: 'zoom'
        }
      }
    ]
  },
  // {
  //   path: '/snapshot/engagement',
  //   name: 'EngagementSnapshot',
  //   component: EngagementSnapshot,
  //   meta: {
  //     requiredSessionState: REQUIRED_SESSION_STATE_USER
  //   }
  // },
  {
    path: '/sign-up',
    name: 'Signup',
    component: Signup,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_VISITOR
    }
  },
  {
    path: '/account/people',
    name: 'Account',
    component: Account,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_OWNER
    },
    children: [
      {
        path: '/account/people',
        name: 'AccountPeople',
        component: AccountPeople,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_OWNER
        }
      },
      {
        path: '/account/details',
        name: 'AccountDetails',
        component: AccountDetails,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_OWNER
        }
      }
    ]
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_USER
    },
    children: [
      {
        name: 'Survey',
        path: 'survey',
        component: Survey,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        name: 'Journal',
        path: 'journal',
        component: Journal,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        path: 'results',
        name: 'Results',
        component: Results,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        },
        children: [
          {
            name: 'PersonalEngagementReport',
            path: 'engagement',
            component: PersonalEngagementReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          },
          {
            name: 'PersonalVigorReport',
            path: 'vigor',
            component: PersonalVigorReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          },
          {
            name: 'PersonalAbsorptionReport',
            path: 'absorption',
            component: PersonalAbsorptionReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          },
          {
            name: 'PersonalDedicationReport',
            path: 'dedication',
            component: PersonalDedicationReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          },
          {
            name: 'PersonalAnxietyReport',
            path: 'anxiety',
            component: PersonalAnxietyReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          },
          {
            name: 'PersonalPsychosocialWorkloadReport',
            path: 'psychosocial-workload',
            component: PersonalPsychosocialWorkloadReport,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/profile',
    component: Profile,
    props: route => ({ passwordRecovery: route.query.passwordRecovery }),
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_USER
    },
    children: [
      {
        path: '',
        name: 'ProfileDetails',
        component: ProfileDetails,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        path: 'password',
        name: 'ChangePassword',
        component: ProfileChangePassword,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        path: 'messaging',
        name: 'MessagingOptions',
        component: ProfileMessagingOptions,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        path: 'remove',
        name: 'ProfileRemoveAccount',
        component: ProfileRemoveAccount,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/personal/survey'
  },
  {
    path: '/challenges',
    component: Challenges,
    meta: {
      requiredSessionState: REQUIRED_SESSION_STATE_USER
    },
    children: [
      {
        path: '',
        name: 'Challenges',
        component: ChallengeThemes,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        }
      },
      {
        path: ':themeId',
        name: 'ChallengeTheme',
        component: ChallengeTheme,
        meta: {
          requiredSessionState: REQUIRED_SESSION_STATE_USER
        },
        children: [
          {
            name: 'Challenge',
            path: ':challengeId',
            component: Challenge,
            meta: {
              requiredSessionState: REQUIRED_SESSION_STATE_USER,
              transitionName: 'zoom'
            }
          }
        ]
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // resolve(savedPosition)
        resolve({ x: 0, y: 0 })
      }, 200)
    })
  }
})

router.beforeEach((to, from, next) => {
  const requiredSessionState = to.matched.find(record => record.meta.requiredSessionState).meta.requiredSessionState

  if (to.hash && to.hash.indexOf('/a/') >= 0) {
    const splitHash = to.hash.split('/')
    const token = splitHash[2]

    store.dispatch('tokenLogin', { token: token }).then((success) => {
      const scaleId = splitHash[3]
      const questionId = splitHash[4]
      const answerValue = splitHash[5]
      next({ path: '/personal/survey', query: { s: scaleId, q: questionId, a: answerValue } })
    }).catch(() => {
      next({ path: '/welcome/sign-in' })
    })
  } else if (to.hash && to.hash.indexOf('/r/') >= 0) {
    const token = to.hash.substr(to.hash.indexOf('validate-email/') + 5)
    const decodedToken = VueJwtDecoder.decode(token)
    // Check if token is valid
    store.dispatch('tokenLogin', { token: token }).then((success) => {
      if (decodedToken.redirect === 'home') {
        next({ path: '/personal/survey' })
      } else if (decodedToken.redirect === 'personal') {
        next({ path: '/personal/survey' })
      } else if (decodedToken.redirect === 'password-recovery') {
        next({ path: '/profile/password', query: { passwordRecovery: true } })
      } else if (decodedToken.redirect === 'profile/messaging') {
        next({ path: '/profile/messaging' })
      } else if (decodedToken.redirect.indexOf('challenges') === 0) {
        next({ path: decodedToken.redirect })
      } else {
        next({ path: '/personal/survey' })
      }
    }).catch(() => {
      next({ path: '/welcome/sign-in' })
    })
  } else if (to.hash && to.hash.indexOf('validate-email') >= 0) {
    const emailValidationToken = to.hash.substr(to.hash.indexOf('validate-email/') + 15)
    next({ path: 'validate-email', query: { token: emailValidationToken } })
  } else if (requiredSessionState === REQUIRED_SESSION_STATE_ANY) {
    next()
  } else if (requiredSessionState === REQUIRED_SESSION_STATE_VISITOR && store.getters.isLoggedIn === true) {
    next({ path: '/personal/survey' })
  } else if ((requiredSessionState === REQUIRED_SESSION_STATE_USER || requiredSessionState === REQUIRED_SESSION_STATE_OWNER) && !store.getters.isLoggedIn) {
    next({ path: '/welcome/sign-in', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  analytics.page()
})

export default router
